import { User } from '../types';
import { showToRoles } from './show-to-roles';

export const filterWithUserId = (filters: any, user: User) => {
  let userIdObj = {};

  if (showToRoles(['YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'], user)) {
    userIdObj = { yardCompanyId: user.yardCompanyEmployee.yardCompanyId };
    delete filters.yardCompanyId;
  } else if (showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER'], user)) {
    userIdObj = { yardId: user.yardEmployee.yardId };
    delete filters.yardId;
  } else if (showToRoles('client', user)) {
    userIdObj = { clientId: user.clientEmployee.clientId };
    delete filters.clientId;
  }

  return { ...filters, ...userIdObj };
};
